export default "__VITE_PUBLIC_ASSET__1dbb3405__"